const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    shop_id: {
      type: 'string',
      title: 'فروشگاه',
    },
    role_id: {
      type: 'string',
      title: 'نقش',
    },
  },
});

export default schema;
